import { render } from "./headerComponent.vue?vue&type=template&id=07e5c298&scoped=true"
import script from "./headerComponent.vue?vue&type=script&lang=js"
export * from "./headerComponent.vue?vue&type=script&lang=js"

import "./headerComponent.vue?vue&type=style&index=0&id=07e5c298&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07e5c298"]])

export default __exports__